<div class="d-flex flex-1" id="container" [class.fullscreen]="isFullscreen" #container (ngxResize)="onResized($event)">
    @if (errorMessage) {
        <kui-alert type="danger" class="mb-0 position-absolute w-100 key-alert-wrapper" style="z-index: 2000">
            <kui-icon name="ban" size="sm"></kui-icon>
            <span>{{ errorMessage }}</span>
        </kui-alert>
    }

    <div key-content-container class="map flex-1"></div>

    <kui-dropdown #contextMenuRef class="context-menu" [style]="'none'" [menu]="contextMenu" [parentElement]="containerRef.nativeElement"> </kui-dropdown>

    <key-map-toolbar [hidden]="!(activeControls?.length > 0)"
        [controls]="activeControls"
        [isFullscreen]="isFullscreen"
        [baseLayers]="toolbarBaseLayers"
        [overlays]="overlays"
        [mapHeight]="hostHeight"
        [supportsMarkerClustering]="enableMarkerClustering"
        (enterFullscreen)="enterFullscreen()"
        (exitFullscreen)="exitFullscreen()"
        (zoomIn)="map.zoomIn()"
        (zoomOut)="map.zoomOut()"
        (toolbarToggled)="onToolbarToggled.emit($event)"
        (click)="toolbarClicked($event)"
        (reset)="resetMap()">
    </key-map-toolbar>

    @if (loading) {
        <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center">
            <kui-loader></kui-loader>
        </div>
    }
</div>
